import { render, staticRenderFns } from "./FormControlTypeRelationshipManyToMany.vue?vue&type=template&id=ef5bd784&scoped=true"
import script from "./FormControlTypeRelationshipManyToMany.vue?vue&type=script&lang=js"
export * from "./FormControlTypeRelationshipManyToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5bd784",
  null
  
)

export default component.exports